import React from 'react'
import { DialogContent } from '@mui/material'

interface ModalBodyProps {
  content: React.ReactNode
}

const ModalBody: React.FC<ModalBodyProps> = ({ content }) => {
  return <DialogContent dividers>{content}</DialogContent>
}

export default ModalBody
